export const defaultReceivedMessageAnchorStyles = {
  color: "white",
  filter: "none"
};